import { Club } from '@/fairplayer/domain/club/Club';
import { ClubState } from '@/fairplayer/domain/club/ClubState';
import { fromPartner, PartnerUi } from '@/fairplayer/primary/club/Partner.ui';
import { ClubSummaryUi, fromClubSummary } from '@/fairplayer/primary/homepage/club-selection/ClubSummary.ui';
import { ClubModel } from '@/fairplayer/domain/club/ClubModel';
import { FiatUi, fromFiat } from '@/common/primary/token/Fiat.ui';
import { renderMarkdown } from '@/common/primary/MarkdownRenderer';
import { MarkdownUi } from '@/common/primary/Markdown.ui';

export const VIP_PARTIAL_SLUGS = ['club70', 'psg-x-jordan'];

export interface ClubUi {
  name: string;
  platformName: string;
  slug: string;
  model: ClubModel;
  logoUrl: string;
  bannerUrl: string;
  contactEmail: string;
  state: ClubState;
  eulaUrl: string;
  sfcUrl: string;
  privacyPolicyUrl: string;
  referralNeeded: boolean;
  isFoundation: boolean;
  isMarketplace: boolean;
  isPopup: boolean;
  fiatAccepted: boolean;
  coinsEnabled: boolean;
  promoteDonation: boolean;
  vip: boolean;
  webappUrl: string;
  presentation?: MarkdownUi;
  membershipFee?: FiatUi;
  languages: string[];
  partners: PartnerUi[];
  linkedClubs: ClubSummaryUi[];
}

export const fromClub = (club: Club): ClubUi => ({
  name: club.name,
  platformName: club.platformName,
  slug: club.slug,
  model: club.model,
  logoUrl: club.logoUrl,
  bannerUrl: club.bannerUrl,
  contactEmail: club.contactEmail,
  state: club.state,
  eulaUrl: club.eulaUrl,
  sfcUrl: club.sfcUrl,
  privacyPolicyUrl: club.privacyPolicyUrl,
  referralNeeded: club.referralNeeded,
  isFoundation: club.model === ClubModel.FOUNDATION,
  isMarketplace: club.model === ClubModel.MARKETPLACE,
  isPopup: club.model === ClubModel.POPUP,
  fiatAccepted: club.fiatAccepted,
  coinsEnabled: club.coinsEnabled,
  promoteDonation: club.promoteDonation,
  vip: VIP_PARTIAL_SLUGS.some(slug => club.slug.includes(slug)),
  webappUrl: club.webappUrl,
  presentation: club.presentation.map(renderMarkdown).orElseUndefined(),
  membershipFee: club.membershipFee.map(fromFiat).orElseUndefined(),
  languages: club.languages,
  partners: club.partners.map(fromPartner),
  linkedClubs: club.linkedClubs.map(fromClubSummary),
});
